import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { touringHoursPath } from 'src/services/api/touring-hours/paths';

export function useClearTouringHours(propertyId?: number | null) {
    const queryClient = useQueryClient();

    return useMutation<void, Error>(
        async () => {
            await apiClient(touringHoursPath(propertyId as number), { method: 'delete' });
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.touringHours);
                queryClient.invalidateQueries(queryKeys.properties);
            },
        }
    );
}
